module.exports = __webpack_public_path__ + "img/glogo.ebc50f28.svg";